<template>
    <vx-card title="MAP Revaluation Form">
        <div class="mb-6 vx-row">
            <vs-button @click="handleBack()" class="mt-2 ml-4" color="danger" icon-pack="feather"
                icon="icon-arrow-left">Back</vs-button>
        </div>
        <div class="flex md:flex-row">
            <div class="w-full pr-6 md:basis-1/2">
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Warehouse Code</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="this.wh_code" disabled :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Warehouse Name</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="this.wh_name" disabled :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>SKU Code</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input v-model="this.item_code" disabled :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Item Name</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input v-model="this.item_name" disabled :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Current MAP</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input v-model="this.current_map" disabled :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Suggestion MAP</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input v-model="this.suggestion_map" disabled :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>New MAP</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input v-model="this.new_map" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-6 vx-row">
            <vs-button class="mt-2 ml-4" @click="handleSave()">Save</vs-button>
        </div>
    </vx-card>
</template>

<script>
import Date from "@/components/Date.vue";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
    components: {
        Date,
        vSelect,
        Datepicker,
    },
    mounted() {
        this.item_code = this.$route.query.sku;
        this.wh_code = this.$route.query.wh;
        this.wh_id = this.$route.query.id;
    },
    data() {
        return {
            wh_code: "",
            wh_name: "",
            item_code: "",
            item_name: "",
            current_map: 0,
            suggestion_map: 0,
            new_map: 0,
            wh_id: 0,
        }
    },
    methods: {
        paramData() {
            return {
                warehouse_id: this.wh_id,
                warehouse_code: this.wh_code,
                warehouse_name: this.wh_name,
                item_code: this.item_code,
                item_name: this.item_name,
                current_map: this.current_map,
                suggestion_map: this.suggestion_map,
                new_map: this.new_map,
            }
        },
        handleBack() {
            this.$router.push({
                name: "map-revaluation",
            });
        },
        handleSave() {
            this.$vs.loading();
            this.$http
            .post("/api/wms/v1/map-revaluation/create", this.paramData())
            .then(resp => {
            this.$vs.loading.close();
            if (resp.code == 200) {
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle"
                });
            } else {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: resp.message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle"
                });
            }
            })
            .catch(error => {
                this.$vs.loading.close();
                console.log(error);
            });
            this.$vs.loading.close();
        }
    }
}
</script>

<style>
/* td.td.vs-table--td {
    vertical-align: text-top !important;
}

.vs-input--input:disabled,
input:disabled {
    pointer-events: auto !important;
} */
</style>